import { Http } from '../http';
import axiosInstance from './axios-instance';

export default {
  getSports: function(locale, market, offering, logData, useProdApis = false) {
    const url = '/sports';
    const params = { lang: locale, market, offering, useProdApis };

    return new Http(axiosInstance.get())
      .get(logData, url, params, true)
      .then(response => response.data);
  },

  getQuickLinks: function(
    locale,
    market,
    offering,
    logData,
    useProdApis = false
  ) {
    const url = '/popular';
    const params = { lang: locale, market, offering, useProdApis };

    return new Http(axiosInstance.get())
      .get(logData, url, params, true)
      .then(response => response.data);
  },

  /*  getQuickLinksTest: function (/!*locale, market, offering, logData, useProdApis = false*!/) {
    const testData = [{
      id: 1000093190,
      sortOrder: "3",
      sport: "FOOTBALL"
    }];
    return new Promise((resolve) => {
      setTimeout(resolve, 2000, testData);
    });
  },*/

  getCasinoGames: function(
    brand,
    subbrand,
    isMobile,
    logData,
    useProdApis = false
  ) {
    const url = '/casinogames';
    const params = { brand, subbrand, isMobile, useProdApis };

    return new Http(axiosInstance.get())
      .get(logData, url, params, true)
      .then(response => response.data);
  },

  getSportCategories: function(
    langISO2,
    countryISO3,
    brand,
    logData,
    useProdApis = false
  ) {
    const url = '/sportcategories';
    const params = { lang: langISO2, country: countryISO3, brand, useProdApis };

    return new Http(axiosInstance.get())
      .get(logData, url, params, true)
      .then(response => response.data);
  },

  getSearchResults: function(
    langISO2,
    countryISO3,
    brand,
    term,
    logData,
    useProdApis = false
  ) {
    const url = '/search';
    const params = {
      lang: langISO2,
      country: countryISO3,
      brand,
      term,
      useProdApis
    };

    return new Http(axiosInstance.get())
      .get(logData, url, params, true)
      .then(response => response.data);
  },

  getHighlightsStripData: function(
    sportGroups,
    locale,
    market,
    offering,
    logData,
    useProdApis = false
  ) {
    const url = '/highlightsStripData';
    const params = { lang: locale, market, offering, useProdApis };
    const data = sportGroups && sportGroups.length ? { sportGroups } : {};

    return new Http(axiosInstance.get())
      .post(logData, url, data, params, true)
      .then(response => response.data);
  },

  getIconsSVG() {
    const url = '/assets/img/square.svg';

    return new Http(axiosInstance.get())
      .get({}, url, null, null, false)
      .then(response => response.data);
  },

  getBetsRecommendations(
    cid,
    systemId,
    topRecommendations,
    logData,
    useProdApis = false
  ) {
    const url = '/betsrecommendations';
    const params = { cid, systemId, topRecommendations, useProdApis };

    return new Http(axiosInstance.get())
      .get(logData, url, params, true)
      .then(response => response.data);
  }
};
